export default {
  shared: {
    filter: {
      all: 'All',
      allType: 'All Type',
      product: 'Product',
      brand: 'Brand',
      typeFilter: 'Type Filter',
      type: 'Type',
      reset: 'Reset',
      confirm: 'Confirm',
      filter: 'Filter',
      timeFilter: 'Time Filter',
      time: 'Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      selectStartDate: 'Select Start Date',
      selectEndDate: 'Select End Date',
      sort: 'Sort',
      noFilter: 'No Filter',
      viewStore: 'View Store',
      distanceNearest: 'Distance: Nearest',
      distanceFarthest: 'Distance: Farthest',
      distanceLatest: 'Store Mapping: Latest',
      distanceEarliest: 'Store Mapping: Earliest',
      operationTopmost: 'Operation: topmost',
      operationBottonmost: 'Operation: bottonmost',
      containAny: 'Contain(Any)',
      containAll: 'Contain(All)',
      notContainAny: 'Not contain(Any)',
      notEqualTo: 'Not equal to(All)',
      me: 'Me',
      customize: 'Customize',
      sVIPCore: 'SVIP Core',
      vIPCore: 'VIP Core',
      potential: 'Potential',
      toBeVerified: 'To Be Verified',
      activated: 'Activated',
      participated: 'Participated',
      notParticipated: 'Not Participated',
      notActivated: 'Not Activated',
      yes: 'Yes',
      no: 'No',
      unknown: 'Unknown',
      lessThanDays: 'Less than 7 days',
      timeDays: '7~15 days',
      unitedStates: 'United States',
      unitedKingdom: 'United Kingdom',
      russia: 'Russia',
      high: 'High',
      average: 'Average',
      low: 'Low',
      rich: 'Rich',
      good: 'Good',
      poor: 'Poor',
      richTop: 'Rich: Top, mid-tier, and tail brands',
      goodTop: 'Good: Top and mid-tier brands',
      poorMainly: 'Poor: Mainly top brands',
      mD: 'MD',
      kA: 'KA',
      sDSmokeDistro: 'SD(Smoke Distro)',
      sDMultiItemDistro: 'SD(Multi-item Distro)',
      notSet: 'Not set',
      effective: 'Effective',
      selectDate: 'Select Date',
      incentiveHistory: 'Incentive History',
      accountManagement: 'Account Management',
      shopkeeper: 'Shopkeeper',
      procMgr: 'Proc Mgr',
      salesclerk: 'Salesclerk',
      brandFilter: 'Brand Filter',
      inWeek: 'In a week',
      inTwoWeeks: 'In two weeks',
      inMonth: 'In a month'
    },
    title: {
      basicInfo: 'Basic Info.',
      storeTag: 'Store Tag',
      productListed: 'Product Listed',
      incentive: 'Incentive',
      eventHeld: 'Has a Pop-up Event been held?',
      storeAssignment: 'Store Assignment',
      filterDepartment: 'Filter by department',
      filterPerson: 'Filter by Person',
      storeVisit: 'Store Visit',
      visitOrNot: 'Visit or Not',
      timeSinceLastVisit: 'Time Since Last Visit',
      days: 'Days',
      reOrderOrNot: 'ReOrder or Not',
      visitByBa: 'Visit by BA',
      illDesc: 'Illustration Description',
      listState: 'List State',
      ros: 'ROS',
      selectRegion: 'Select Region',
      selectPlan: 'Select Plan',
      preparations: 'Preparations',
      estimationOfResults: 'Estimation of results',
      eventRecord: 'Event Record',
      selectAPolicy: 'Select a Policy',
      whichDay: 'Which Day',
      theNumberOfProductsSold: 'The number of products sold',
      marketInsight: 'Market Insight',
      pleaseSelectYourWorkItems: 'please select your work items',
      oversightMatters: 'Oversight matters',
      mySchedule: 'My Schedule',
      quickEntrance: 'Quick entrance',
      state: 'State',
      prompt: 'Prompt',
      participationRecord: 'Participation Record',
      activatedStores: 'Activated Stores',
      pointsRedemption: 'Points Redemption',
      retailOperationSystem: 'Retail Operation System',
      selectYearAndMonth: 'Select Year and Month',
      overdueStoreFailureToFollowUp: 'Overdue store failure to follow up',
      anEventStoreToBeHeld: 'An event store to be held',
      others: 'Others',
      distributorMapping: 'Distributor Mapping',
      mappingSucceed: 'Mapping Succeed',
      distributorInfo: 'Distributor Info',
      storeDevelopment: 'Store Development',
      storeMapping: 'Store Mapping',
      distributorOperation: 'Distributor Operation',
      storeInfo: 'Store Info',
      selectGroup: 'Select Group',
      createANewGroup: 'Create a new group',
      reOrderSellIn: 'ReOrder(Sell-in)',
      orderDetail: 'Order Detail',
      selectItemOfWork: 'Select item of work',
      manageMyGroups: 'Manage My Groups',
      editGroupName: 'Edit group name',
      storesToBeAllocated: 'Stores to be allocated',
      transferAndAllocate: 'Transfer and allocate',
      transferAllocationRecords: 'Transfer & Allocation Records',
      createdSuccessfully: 'Created Successfully',
      orderUpdateRecord: '订单修订记录',
      minDays: 'Min Days',
      maxDays: 'Max Days'
    },
    titleOne: 'Filter by the following condition',
    titleTwo: 'Only last visit by this person',
    titleThree: "You recently updated the store's ReOrder, do you continue to edit?",
    titleFour: 'You recently updated the visit information for this store. Continue editing?',
    titleFive: "Recently updated the store's ReOrder, still want to add a ReOrder?",
    titleSix: 'visit for this store was recently updated. Still create a new visit?',
    titleSeven: 'The following activity summary is automatically generated based on the data you have entered',
    titleEight: 'No event is permitted to run for more than {days} days',
    titleNine: 'The event status must be submitted by time.  An event only needs to be filled in once',
    titleTen: 'The event status must be submitted daily, An event summary will be automatically generated upon conclusion',
    titleEleven: 'Step1 Current Event Basic Info',
    titleTwelve: 'Step2 {type} Basic Info',
    titleThirteen: 'The following information will be automatically displayed if it has been fiiled in before.',
    titleFourteen: 'Please check if there are any updates. The latest information will be automatically updated to the basic information after the event application is successfully submitted.',
    titleFifteen: 'Step3 Current Product Listings & Sales Data',
    titleSixteen: 'Step4 Preparation Status of the Current Event',
    titleSeventeen: 'Invite fans to join the community and get {totalIntegral} points',
    titleEighteen: "Confirm removal of this participant's eligibility?",
    titleNineteen: 'Send the above notification content to the person via SMS',
    titleTwenty: 'Invite the staff to open the qualification to receive bonuses',
    titleTwentyOne: "Redemption Successful. {currentIntegral} credits have been deducted from this employee's account",
    titleTwentyTwo: 'Are you sure you want to remove this product?',
    titleTwentyThree: 'has applied to kicking out of Operation',
    titleTwentyFour: 'Please describe the reason for kicking out',
    titleTwentyFive: "Kicking out a store will terminate the store's authority and you can't update the store's operation information, so please proceed with caution",
    titleTwentySix: 'There are event invitations to be Launched at this store. View invitation information',
    titleTwentySeven: '{backlogUserName} The event {sourceName} will start at {backlogTime}, go to view',
    titleTwentyEight: 'The store level has not been determined since the end of the store activity. Go to submit',
    titleTwentyNine: 'Transfer the store to a "operation team" and assign a supervisor to it',
    titleThirty: 'Once the transfer is successful and unrecoverable, make sure that the store has already put the product on the shelves',
    titleThirtyOne: 'The visit plan has been created successfully, and Stores/Distributors can beth added to the planned visit route',
    titleThirtyTwo: 'Add {keyVal} to more visit plans',
    titleThirtyThree: 'Any product listing status to update?',
    titleThirtyFour: 'Fill Min Days, Max Days, or both. Leave a field blank for no corresponding limit.',
    stores: 'Stores',
    store: 'Store',
    distributor: 'Distributor',
    distributors: 'Distributors',
    plannedVisitDate: 'Planned visit date',
    loading: 'Loading...',
    salesPcsWeek: 'Sales(Pcs/week)',
    inventoryPcs: 'Inventory(Pcs)',
    reorderPcs: 'Reorder(Pcs)',
    psi: 'PSI',
    applicable: 'Applicable',
    rules: 'Rules',
    eventPolicy: 'Event Policy',
    onSite: 'On Site',
    offSite: 'Off Site',
    webSite: 'Web Site',
    success: 'success',
    buy: 'Buy',
    get: 'Get',
    bA: 'BA',
    notStarted: 'Not started',
    startingNow: 'Starting now',
    end: 'End',
    nonEditable: 'Non-editable',
    feedback: 'Feedback',
    materialSample: 'Material/Sample',
    report: 'Report',
    daily: 'Daily',
    day: 'Day',
    summary: 'Summary',
    event: 'Event',
    byTime: 'By Time',
    byDay: 'By Day',
    more: 'More',
    visit: 'Visit',
    development: 'Development',
    operation: 'Operation',
    theFirstSaleOrInvitation: 'The First Sale or Invitation',
    toBeAllocated: 'To be allocated',
    kickOutOfOperation: 'Kick out of Operation',
    overdueFollowUp: 'Overdue follow-up',
    anEventToBeHeld: 'An event to be held',
    visitPlan: 'Visit Plan',
    point: 'Point',
    bindProduct: 'Bind Product',
    uploadSalesReceipt: 'Upload Sales Receipt',
    inviteFansToJoinTheCommunity: 'Invite fans to join the community',
    submissionTime: 'Submission Time',
    auditResult: 'Audit Result',
    earnedPoints: 'earned {totalIntegral} points',
    productDetails: 'Product Details',
    sN: 'SN',
    reason: 'Reason',
    sellOutProduct: 'Sell-out Product',
    completed: 'Completed',
    pendingReview: 'Pending Review',
    rejected: 'Rejected',
    underReview: 'Under Review',
    storeParticipant: 'Store Participant',
    creditTransactionHistory: 'Credit Transaction History',
    productBindingRecords: 'Product Binding Records',
    pointsRank: 'Points Rank',
    storeIncentive: 'Store Incentive',
    modifyPersonalInformation: 'Modify personal information',
    balance: 'Balance',
    creditEarned: 'Credit Earned',
    redeemedCredit: 'Redeemed Credit',
    selectGiftToRedeem: 'Select a Gift to Redeem',
    need: 'Need',
    proofOfDelivery: 'Proof of Delivery',
    creditBreakdown: 'Credit Breakdown',
    confirmRedemaption: 'Confirm Redemaption',
    insufficientPoints: 'Insufficient Points',
    deadline: 'Deadline',
    collecting: 'Collecting',
    closed: 'Closed',
    byVisitBy: 'by Visit by',
    daysAgo: 'days ago',
    today: 'today',
    yesterday: 'yesterday',
    storeAllocationTime: 'Store allocation time',
    dateOfInvitation: 'Date of invitation',
    expectTime: 'Expect time',
    timeOfApplication: 'Time of Application',
    applicant: 'Applicant',
    storeID: 'Store ID',
    storesLevel: 'Stores Level',
    giveUpReason: 'Give-up Reason',
    reviewStatus: 'Review Status',
    approver: 'Approver',
    approvalTime: 'Approval time',
    approved: 'Approved',
    myApproval: 'My Approval',
    mapping: 'Mapping',
    visitSellIn: 'Visit & Sell-in',
    reorder: 'Reorder',
    transferAllocation: 'Transfer & Allocation',
    by: 'by',
    metre: 'm',
    kilometer: 'km',
    storeActivity: 'Store Activity',
    relevantVisitPlans: 'Relevant Visit Plans',
    addNewStoreMapping: 'Add New Store Mapping',
    updateStoreMappingInformation: 'Update Store Mapping Information',
    setStoreLabels: 'Set store labels',
    launchPopUpEvent: 'Launch Pop-up Event',
    updatePopUpEvent: 'Update Pop-up Event',
    cancelPopUpEvent: 'Cancel Pop-up Event',
    reportPopUpEventExecutionStatus: 'Report Pop-up Event Execution Status',
    sellOutDataMaintenance: 'Sell-out data maintenance',
    setStoreTag: 'Set store Tag',
    materialSampleDeliveryDataMaintenance: 'Material & Sample delivery data maintenance',
    storeIncentiveInviteEmployeeToActivate: 'Store Incentive: Invite Employee to Activate',
    storeIncentiveDeactivateEmployeeAccount: 'Store Incentive: Deactivate Employee Account',
    storeIncentiveBindProduct: 'Store Incentive: Bind Product',
    storeIncentiveUploadSalesProof: 'Store Incentive: Upload Sales Proof',
    redeemIncentiveRewardsForEmployees: 'Redeem Incentive Rewards for Employees',
    addNewStoreVisit: 'Add New Store Visit',
    updateStoreVisitInformation: 'Update Store Visit Information',
    newVisitSellIn: 'New Visit & Sell-in',
    updateVisitSellIn: 'Update Visit & Sell-in',
    newReOrder: 'New ReOrder',
    modifyReOrder: 'Modify ReOrder',
    storesAreTransferredAndAllocatedTo: 'Stores are transferred and allocated to ',
    cancelAllocationOfStores: 'Cancel allocation of stores',
    setAssignedBABDInTheManagementSystem: 'Set Assigned BA/BD in the Management System',
    aplyToKickOutOfOperation: 'Apply to kick out of Operation',
    agreeToApplicationForKickOutOfOperation: 'Agree to application for kick out of Operation',
    rejectApplicationForKickingOutUpStore: 'Reject application for kicking out up store',
    newDistributorMapping: 'New Distributor Mapping',
    updateDistributorMapping: 'Update Distributor Mapping',
    setTheResponsiblePerson: 'Set the responsible person',
    brandDayApplication: 'Brand Day Application',
    modifyBrandDayApplicationInfo: 'Modify Brand Day Application info',
    cancelBrandDay: 'Cancel Brand Day',
    reportingOnTheBrandDayExecution: 'Reporting on the Brand Day Execution',
    newDistributorVisit: 'New Distributor visit',
    updateDistributorVisit: 'Update Distributor visit',
    addNewVisitSchedulePlannedVisitDate: 'Add New Visit Schedule, Planned Visit Date：',
    cancelVisitSchedule: 'Cancel Visit Schedule',
    updateStoreInfoBy: 'update store info by',
    listingProduct: 'Listing Product',
    selectStore: 'Select Store',
    selectDistributor: 'Select Distributor',
    activity: 'Activity',
    records: 'records',
    hideUpdate: 'Hide "update"',
    dynamics: 'Dynamics',
    updateRecord: 'Update Record',
    current: 'Current',
    preEvent: 'Pre-event',
    storeTagChange: 'Store Tag change',
    modifyStoreTag: 'Modify Store Tag',
    notChangedYet: 'Not changed yet',
    kickOut: 'Kick out',
    storeOperation: 'Store Operation',
    applicationForKickOutOfOperation: 'application for kick out of Operation',
    storeToDoItems: 'Store To-Do Items',
    eventInvite: 'Event Invite',
    eventExecute: 'Event Execute',
    nearbyStores: 'Nearby Stores',
    locationName: 'Location name',
    visitTime: 'Visit Time',
    eventInvitations: 'Event invitations',
    markToIgnoreThisTransferAllocation: 'Mark to ignore this transfer & allocation',
    transferAndAssignStoresTo: 'Transfer and assign stores to',
    schedule: 'Schedule',
    distroInfo: 'Distro info',
    multiStopRoute: 'Multi-stop Route',
    createVisitPlan: 'Create a visit plan',
    addToVisitPlan: 'Add to Visit Plan',
    selectType: 'Select Type',
    createNewVisitPlan: 'Create new visit plan',
    automaticallyAddCurrentItemAfterCreation: 'Automatically add current item after creation',
    addRetailStoresToThePlan: 'Add retail stores to the plan',
    addToExistingPlan: 'Add to existing plan',
    selectFromExistingPlan: 'Select from 4 existing plan(s)',
    addDistributorsToThePlan: 'Add distributors to the plan',
    changeDetails: 'Change Details',
    removedProducts: 'Removed Products',
    quanntityGivenAway: 'Quanntity given away',
    quanntitySold: 'Quanntity sold',
    modifiedProductQuantity: 'Modified Product Quantity',
    from: 'from',
    to: 'to',
    removedDistributor: 'Removed Distributor',
    none: 'None'
  },
  form: {
    pleaseSelect: 'Please select',
    basicInfo: 'Basic info.',
    storeID: 'StoreID',
    distributorID: 'Distributor ID',
    storeTag: 'Store Tag',
    assignedBaBd: 'Assigned BA / BD',
    outsidePicture: 'Outside Picture',
    address: 'Address',
    storeType: 'Store Type',
    businessStatus: 'Business Status',
    business: 'Business',
    temporarilyClosed: 'Temporarily Closed',
    permanentlyClosed: 'Permanently Closed',
    invalid: 'Invalid',
    distributorTag: 'Distributor Tag',
    keyDistributor: 'Key Distributor',
    notKeyDistributor: 'Not Key Distributor',
    distributorType: 'Distributor Type',
    businessType: 'Business Type',
    chainOrNot: 'Chain or not',
    numberofChainStores: 'Number of Chain Stores',
    decisionMakerInfo: 'Decision-maker Info.',
    decisionMakerRole: 'Decision Maker Role',
    decisionMakerName: 'Decision Maker Name',
    phoneNumber: 'Phone Number',
    phone: 'Phone',
    email: 'E-mail',
    notes: 'Notes',
    footTrafficInformation: 'Foot Traffic Information.',
    weekdayFootTraffic: 'Weekday Foot Traffic',
    weekdayPeakTraffic: 'Weekday Peak Traffic',
    timePeriods: 'Time Periods',
    weekendFootTraffic: 'Weekend Foot Traffic',
    weekendPeakTraffic: 'Weekend Peak Traffic',
    customerReach: 'Customer Reach',
    numberOfAffiliatedCoreStore: 'Number of Affiliated Core Store',
    corePromotedProductBrand: 'Core Promoted Product Brand',
    disposableBrandDiversity: 'Disposable Brand Diversity',
    promotionCapability: 'Promotion Capability',
    officialWebsiteAvailable: 'Official Website Available',
    whatsAppGroupAvailable: 'WhatsApp Group Available',
    facebookInstagramAvailable: 'Facebook / Instagram Available',
    retailPrice: 'Retail Price',
    uSD: 'USD',
    listingStatus: 'Listing Status',
    listed: 'Listed',
    notListing: 'Not Listing',
    listing: 'Listing',
    endOfSales: 'End of Sales',
    lastest: 'Lastest',
    pcs: 'Pcs',
    storeGroup: 'Store Group',
    newGroup: 'New Group',
    ruleTipsOne: 'Please Select a Store',
    selectTimePeriod: 'Select time period',
    startTime: 'Start Time',
    endTime: 'End Time',
    preEventWarmUpCooperation: 'Pre-event warm-up cooperation',
    eventSellInStoreTarget: 'Event Sell-in Store Target',
    salesReorderForecast: 'Sales & Reorder Forecast',
    supportsPreEventInStoreDisplay: 'Supports Pre-Event In-Store Display',
    warmUp: 'Warm-up',
    warmUpType: 'Warm-up Type',
    daysInAdvance: 'Days in Advance',
    eventType: 'Event type',
    popUp: 'Pop Up',
    brandDay: 'Brand Day',
    eventTime: 'Event time',
    selectStartTime: 'Select Start Time',
    selectEndTime: 'Select End Time',
    policy: 'Policy',
    listingOrNot: 'Listing or Not',
    weeklySalesInventoryBrforeEventPcs: 'Weekly Sales & Inventory Brfore Event(Pcs)',
    wayOfList: 'Way of list',
    totalOpenSystemsSales: 'Total Open Systems Sales(pcs / week)',
    totalDisposableSales: 'Total Disposable Sales(pcs / week)',
    salesPcsWeek: 'Sales(pcs / week)',
    distributorName: 'Distributor Name',
    storeName: 'Store Name',
    promotionCapabillty: 'Promotion Capabillty',
    totalStoreTraffic: 'Total Store Traffic',
    disposable: 'Disposable',
    openSystem: 'Open System',
    otherCategory: 'Other category',
    newBuyersReOrderStoreCount: 'New Buyers & ReOrder Store Count',
    newBuyers: 'New buyers',
    reorderBuyers: 'Reorder buyers',
    productDailySales: 'Product Daily Sales',
    salesPcs: 'Sales(Pcs)',
    pO: 'PO',
    promotionEffect: 'Promotion Effect',
    eventFeedback: 'Event feedback',
    otherCosts: 'Other costs(materials, etc.)',
    eventPhotos: 'Event photos',
    totalProductSales: 'Total Product Sales',
    total: 'Total',
    passengerFlowStatistics: 'Passenger Flow Statistics(Event Period)',
    actualTraffic: 'Actual Traffic(Event Period)',
    openSystemCustomerTraffic: 'Open System Customer Traffic',
    percentageOfOpenSystem: 'Percentage of Open System',
    disposableCustomerTraffic: 'Disposable Customer Traffic',
    percentageOfDisposable: 'Percentage of Disposable',
    salesPerformance: 'Sales Performance',
    eventActualSales: 'Event Actual Sales (Pcs)',
    salesBeforePromotion: 'Sales Before Promotion(Pcs/Day)',
    totalSalesInStoreDuringEvent: 'Total Sales in Store During Event(Pcs)',
    openSystemSales: 'Open System Sales',
    disposableSales: 'Disposable Sales',
    brandBuyers: 'Brand Buyers',
    salesTargetForThisEventPcs: 'Sales Target for This Event(Pcs)',
    achievementRate: 'Achievement Rate',
    popupDisplayPics: 'POP-UP Display Pics',
    storeCapacityVerification: 'Store capacity verification',
    beforeTheEvent: 'Before the event',
    afterTheEvent: 'After the event',
    averagePassengerFlow: 'Average Passenger Flow',
    averageOfTraffic: 'Average of Traffic',
    averageOfOpenSystemCustomerTraffic: 'Average of Open System Customer Traffic',
    averageOfDisposableCustomerTraffic: 'Average of Disposable Customer Traffic',
    dayOfPromotion: 'Day of Promotion',
    averageSalesPcsDay: 'Average Sales(Pcs/Day)',
    sampleDelivery: 'Sample Delivery',
    totalUsed: 'Total Used',
    inventory: 'Inventory',
    materialDelivery: 'Material Delivery',
    inv: 'Inv',
    salesPerformancePcs: 'Sales Performance (Pcs)',
    totalSalesPcs: 'Total Sales(Pcs)',
    sampleGiveawayPcs: 'Sample Giveaway(Pcs)',
    sellOutOrders: 'Sell-out Orders',
    orders: 'orders',
    sampleConsumed: 'Sample consumed',
    sample: 'Sample',
    sentOut: 'Sent-out',
    samplePhoto: 'Sample Photo',
    image: 'Image',
    name: 'Name',
    position: 'Position',
    userName: 'User Name',
    password: 'Password',
    month: 'Month',
    country: 'Country',
    productInfo: 'Product info',
    marketInformationCollection: 'Market Information Collection',
    eXWEstimatedPrice: 'EXW Estimated Price($)',
    mDWholesalePrice: 'MD Wholesale Price($)',
    storePurchasePrice: 'Store Purchase Price($)',
    retailPriceMoney: 'RetailPrice($)',
    monthlyAverageSalesForKit: 'Monthly Average Sales for Kit(Pcs)',
    consumablesRatio: 'Consumables Ratio (Pod-to-Mod Ratio / Coil-to-Machine Ratio)',
    estimatedPriceOfConsumablesEXW: 'Estimated Price of Consumables EXW($)',
    marketFeedback: 'Market Feedback',
    searchBrandOrProduct: 'Search brand or product...',
    checkInPhoto: 'Check in Photo',
    visitDate: 'Visit Date',
    chooseDate: 'Choose Date',
    otherDistributor: 'Other Distributor',
    overallSalesPerformance: 'Overall Sales Performance',
    totalOpenSystemSales: 'Total Open System Sales(Pcs/week)',
    productSalesInventory: 'Product Sales & Inventory',
    sellInByMyselfThisTime: 'Sell-in by myself this time',
    sellInQuantity: 'Sell-in Quantity(Pcs)',
    photo: 'Photo',
    displayMerchandising: 'Display & Merchandising',
    materialSampleDelivery: 'Material & Sample Delivery',
    materialSamplePhoto: 'Material & Sample Photo',
    wholesaleRetailerPurchasePrice: 'Wholesale & Retailer Purchase Price(USD)',
    wholesalePurchasePrice: 'Wholesale Purchase Price',
    retailerPurchasePrice: 'Retailer Purchase Price',
    competitorPrice: 'Competitor Price',
    testingStationDisplayed: 'Testing Station Displayed',
    posterDisplayed: 'Poster Displayed',
    rollUpBannerOrFloorStandDisplay: 'Roll-up Banner or Floor Stand Display',
    brandBannerDisplayed: 'Brand Banner Displayed',
    testingStationProductModelNotes: 'Testing Station Product Model(Notes)',
    bannerFloorStandProductModelNotes: 'Banner / Floor Stand Product Model(Notes)',
    brandBannerProductModelNotes: 'Brand Banner Product Model(Notes)',
    visitInfo: 'Visit info',
    productListingStatus: 'Product Listing Status',
    listingProductSupplierDistributor: 'Listing Product Supplier(Distributor)',
    other: 'Other',
    brandSupplierDistributor: 'Brand Supplier(Distributor)',
    namePostCodeAddressCity: 'Name/Post Code/Address/City',
    distributorNamePostCodeAddressCityVisitBa: 'Distributor Name/Post Code/Address/City/Visit Ba',
    storeNamePostCodeAddressCityVisitBa: 'Store Name/Post Code/Address/City/Visit Ba',
    createANewStoreMapping: 'Create a new store mapping',
    directOrNot: 'Direct or not',
    sellInFromDistributor: 'Sell-in from Distributor',
    sellInFromAcmefog: 'Sell-in from Acmefog',
    firstTimeOrNot: 'First time or not',
    firistOrder: 'FiristOrder',
    quantitySoldPcs: 'Quantity sold(Pcs)',
    orderSalesVolume: 'Order Sales Volume',
    quantityGivenAwayPcs: 'Quantity given away(Pcs)',
    orderGiftVolume: 'Order Gift Volume',
    totalSellIn: 'Total Sell-in',
    paymentType: 'Payment Type',
    paymentStatus: 'Payment Status',
    paid: 'Paid',
    unpaid: 'Unpaid',
    tax: 'Tax',
    taxInclusive: 'Tax Inclusive',
    taxExclusive: 'Tax Exclusive',
    pOOrder: 'PO Order',
    receipt: 'Receipt',
    productCashCheque: 'Product+Cash/Cheque',
    staffName: 'Staff Name',
    kOSGroupInvitation: 'KOS Group Invitation',
    kOSGroupJoinScreenshot: 'KOS Group Join Screenshot',
    recommendationsEventInvitations: 'Recommendations & Event Invitations',
    isItRecommendedForRoutineOperation: 'Is it recommended for routine operation?',
    isThereAnInvitationForAnEvent: 'Is there an invitation for an event?',
    eventStoreContactName: 'Event Store Contact Name',
    contactPosition: 'Contact Position',
    expectedTime: 'Expected Time',
    sellInPhoto: 'Sell-in Photo',
    recommendedForRoutineOperation: 'Recommended for routine operation',
    invitationsInfo: 'Invitations info',
    directSellIn: 'Direct Sell in',
    afterSalesService: 'After-sales Service',
    lssueDeviceMode: 'Issue Device Mode',
    afterSalesQuantityPcs: 'After-sales Quantity(Pcs)',
    lssusDescription: 'Issus Description',
    servicePhoto: 'Service Photo',
    storeServiceRecords: 'Store Service Records',
    cityNeighborhoodStreetOrBuilding: 'City、Neighborhood、street or building',
    planName: 'Plan Name',
    plannedVisitDate: 'Planned Visit Date',
    addToSchedule: 'Add to Schedule',
    displayPhoto: 'Display Photo',
    poPhoto: 'PO Photo',
    orderModificationHistory: 'Order Modification History',
    editReason: 'Edit Reason',
    currentProductListingStatus: 'Current Product Listing Status'
  },
  button: {
    clear: 'Clear',
    confirm: 'Confirm',
    reset: 'Reset',
    cancel: 'Cancel',
    delete: 'Delete',
    select: 'Select',
    search: 'Search',
    btnCode: 'View Store Invitation QR Code',
    clearSelected: 'Clear Selected',
    selected: 'Selected',
    types: 'types',
    addToStoreGroup: 'Add to Store Group',
    close: 'Close',
    addMoreTime: 'Add more time',
    continueEditing: 'Continue Editing',
    createANewReOrder: 'Create a new ReOrder',
    createNewStoreVisit: 'Create New Store Visit',
    viewRecentReOrder: 'View Recent ReOrder',
    viewRecentVisitRecords: 'View Recent Visit Records',
    exchange: 'Exchange',
    addMoreProduct: 'Add more product',
    gotIt: 'Got it',
    sellOut: 'Sell-out',
    detail: 'Detail',
    previous: 'Previous',
    submit: 'Submit',
    nextStep: 'Next Step',
    eventExecution: 'Event execution',
    stillCancel: 'Still Cancel',
    thinkAgain: 'Think Again',
    navigate: 'Navigate',
    save: 'Save',
    addSalesOrder: 'Add Sales Order',
    storeTagDetermination: 'Store Tag Determination',
    eventApplication: 'Event Application',
    viewStoreMotivationStatus: 'View Store Motivation Status',
    copyLink: 'Copy link',
    remove: 'Remove',
    viewActivatedStores: 'View Activated Stores',
    inviteStoresToParticipate: 'Invite Stores to Participate',
    login: 'Login',
    addProduct: 'Add Product',
    invitationInfo: 'Invitation Info',
    launch: 'Launch',
    reject: 'Reject',
    agree: 'Agree',
    review: 'Review',
    createNewDistributorMapping: 'Create a new Distributor mapping',
    distributorDetial: 'Distributor Detial',
    edit: 'Edit',
    alreadyInOperation: 'Already in operation',
    storeDetial: 'Store Detial',
    addMoreProductForOrder: 'Add more product for order',
    addMoreProductForGiving: 'Add more product for giving',
    ignore: 'Ignore',
    storeInfo: 'Store info',
    assign: 'Assign',
    submitForReview: 'Submit for review',
    addNewGroup: 'Add New Group',
    manage: 'Manage',
    addStoreToGroup: 'Add Store to Group',
    visitInfo: 'Visit Info',
    addMore: 'Add more',
    addStores: 'Add stores',
    addDistributors: 'Add distributors',
    create: 'Create'
  },
  tips: {
    noMore: 'No more',
    noMoreProducts: 'No More Products',
    networkError: 'Network error',
    uploadFailed: 'Upload Failed',
    isRequired: 'is Required',
    pleaseEnterAnInteger: 'Please enter an integer',
    storeTagIsRequired: 'StoreTag is required',
    successSave: 'success save',
    noMoreData: 'No more data',
    noData: 'No Data',
    noAvailablePolicies: 'No available policies',
    pleaseFillInTheSales: 'Please fill in the sales',
    stayTuned: 'Stay tuned',
    noPermissionYet: 'No permission yet',
    pleaseChooseWhichDayToSell: 'Please choose which day to sell',
    locationNotFound: 'Location not found',
    noticeCopiedSuccessfully: 'Notice copied successfully',
    noticeCopiedFailed: 'Notice copied failed',
    nothingMore: "There's nothing more！",
    required: 'Required',
    usernameIsRequired: 'username is required',
    passwordIsRequired: 'password is required',
    loginSuccess: 'Login success',
    accountOrPasswordIncorrect: 'Account or Password incorrect',
    distributorPrice: 'Distributor Price',
    eventCancelled: 'Event Cancelled',
    noMoreStores: 'No More Stores',
    noMoreThan: 'No more than 5',
    pleaseSelectThePlan: 'Please select the plan',
    pleaseSelectAGroup: 'Please Select a Group',
    pleaseEnterGroupName: 'Please enter group name',
    pleaseSelectProduct: 'Please select a product',
    checkInPhotoIsRequired: 'Check in Photo is Required',
    productIsRequired: 'Product is Required',
    sellInFromAcmefogInIsRequired: 'Sell-in from Acmefog in is Required',
    pleaseInputTheSales: 'Please input the sales',
    pending: 'Pending',
    reasonIsRequired: 'Reason is Required',
    addressCopiedSuccessfully: 'Address copied successfully',
    addressCopiedFailed: 'Address copied failed',
    browserDoesNotSupportCopyFunction: 'Browser does not support copy function',
    filterByGroupName: 'Filter by Group Name',
    areYouSureToExit: 'Are you sure to exit?',
    chooseOnePersonAtLeast: 'Choose one person at least',
    planningTheRoute: 'Planning the route',
    messageOne: 'Independently create store groups to categorize stores. Store groups are visible only to group-creator.',
    messageTwo: 'Remove Store from Group (The store itself will not be deleted.)',
    messageThree: 'Invite the staff to open the qualification for receiving awards.',
    messageFour: 'Long press to save to the photo library/album',
    messageFive: 'End time must be after start time',
    messageSix: 'Please fill in the complete information',
    messageSeven: 'Time is incorrect',
    messageEight: 'If this information has been submitted before, historical data will be auto-filled. Please edit directly if there are any changes',
    messageNine: 'Removing the product will clear the entered quantity. Do you want to remove it?',
    messageTen: 'Only enter the pre-event sales data on Day1',
    messageEleven: 'Including All Disposable/Open Competing Brands',
    messageTwelve: 'The event application was submitted successfully, and the event has been automatically added to your daily schedule',
    messageThirteen: 'Once the event is cancelled, you won’t be able to fill out the event report .Confirm to cancel?',
    messageFourteen: 'Clear selected materials and their filled quantities?',
    messageFifteen: 'Confirm deletion of this sales order?',
    messageSixteen: 'To be allocated: submit a visit to a store in the Development Group Store Pool, If at least one product is on the shelves in the visit record, the system will automatically push a "to-assign store" record, and the retail supervisor can transfer and assign the store to the designated person, who will conduct follow-up and maintenance work.',
    messageSeventeen: 'Pending Review: Applications to be reviewed.',
    messgaeEighteen: 'Overdue follow-up: According to business operation indicators, the core / to-test stores are set a corresponding frequency for follow-up, and if the follow-up exceeds the preset interval, an early warning will be taken.',
    messageNineteen: 'To be held activities: when the store is newly assigned to employees, if the store has an event invitation record, employees need to complete the event presentation and upload the implementation within the specified time.',
    messgaeTwenty: 'Join in the Incentive by Scanning the QR Code or Clicking the link',
    messageTwentyOne: 'Please long press the QR code to save to album',
    messageTwentyTwo: 'Failed to get QR code image',
    messageTwentyThree: 'To ensure successful delivery of the active link, please confirm that the entered phone number is correct',
    messageTwentyFour: 'Please enter your name',
    messageTwentyFive: 'Please select a position',
    messageTwentySix: 'Please enter your complete mobile phone number',
    messageTwentySeven: "Activate the event permission and send a notification SMS to the person's mobile phone",
    messageTwentyEight: 'Please Complete Your Information',
    messageTwentyNine: 'lf the application was passed, store authority will be released and transfered to the "Development" area. The previous operation records will be automatically archived and cannot be modified, so please be careful with the operation',
    messageThirty: "Reject {createUserName}'s request to kick out the store, confirm or not",
    messageThirtyOne: 'End date cannot be earlier than start date',
    messageThirtyTwo: 'The current Distributor mapping is successful, and more information can be collected through visit',
    messageThirtyThree: 'Please select visit date',
    messageThirtyFour: 'Please input Distributor of {projectName}',
    messageThirtyFive: 'Please input keywords to search stores',
    messageThirtySix: 'Please input keywords to search Distributor',
    messageThirtySeven: 'Clear selected sample and their filled quantities?',
    messageThirtyEight: 'According to the daily operation of the store, set StoreTag to',
    messageThirtyNine: 'According to the event, StoreTag is set to',
    messageForty: 'Current store mapping is successful, and more store information can be collected by visiting',
    messageFortyOne: 'Change the store status to: {statusVal}, the store will not be mapped and visited, confirm or not?',
    messageFortyTwo: 'Sell-in by myself this time is Required',
    messageFortyThree: 'No sales or listing sales, cannot be recommended',
    messageFortyFour: 'After removal, the store will not appear on the list until ba resubmits',
    messageFortyFive: 'The current Store Tag is：{customerTag}，Do you want to change the Store Tag?',
    messageFortySix: 'Will be transferred to "Development" with permissions revoked. Historical operation records will be archived and uneditable',
    messageFortySeven: 'If you pass the Review, store authority will be released and transfered to the "Expansion" area. The previous operation records will be automatically archived and cannot be modified, so please be careful with the operation',
    messageFortyEight: 'Delete This Group (This action only deletes the group, not the stores within it.)',
    messageFortyNine: 'Confirm the transfer of the store and assign it to the designated responsible person?',
    messageFifty: '是否删除该拜访计划？若已经创建日程将同步取消。',
    messageFiftyOne: 'Do you want to remove the current {targetType} from the visit plan and cancel the associated schedule?',
    messageFiftyTwo: 'Automatically creates visit schedules for stores/distributors added to this plan',
    messageFiftyThree: 'Do you want to delete this visit plan? If a schedule has been created, it will be canceled synchronously'
  }
}
